import $ from "jquery";

export const comparePlansHeaderPosition = () => {
    const topBanner = $('.top-banner');
    const comparePlansTableHeader = $('.compare-plans-table__header');
    let comparePlansHeaderPosition = $('.header').height() + topBanner.height();

    if (topBanner.length !== 0) {
        comparePlansTableHeader.css("top", comparePlansHeaderPosition);
    }
}
